/* Innova Holiday 2026 page for the Shopify theme. GENERATED by shopify/build.js
   from public/assets/js/main.js: queries are scoped to the page's own root
   (#innova-bf), classes and ids carry the ibf- prefix, and the settings come
   from the section. Don't edit this file: change main.js and run the build. */
/* ==========================================================================
   Innova — Black Friday Holiday Page
   Progressive enhancement only: the page is fully readable without this file.
   ========================================================================== */
window.__ibfInit = function () {
  'use strict';
  if (window.__ibfDone) return;

  var ROOT = document.getElementById('innova-bf');
  if (!ROOT) return;
  window.__ibfDone = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------------
     Countdown
     Deadline comes from <body data-deadline="ISO string"> so marketing can
     change the sale end date without touching JS.

     A page can also hand over a run of real dates —
       data-deadline="<Black Friday>,<Cyber Monday>,<Christmas>"
       data-deadline-labels="Black Friday,Cyber Monday,Christmas"
     — and the clock counts to whichever is next, moving on to the one after
     it when that date actually passes. Every date is a fixed calendar date,
     the same for everyone: this is a promotion running in stages, not a timer
     that restarts itself for each visitor. Elements marked
     [data-deadline-label] get the name of the stage being counted to, so the
     wording on the page can never outlive the date beside it.
     ---------------------------------------------------------------------- */
  function initCountdown() {
    var clocks = ROOT.querySelectorAll('[data-countdown]');
    if (!clocks.length) return;

    var labels = (ROOT.getAttribute('data-deadline-labels') || '').split(',');
    var stages = (ROOT.getAttribute('data-deadline') || '').split(',')
      .map(function (s, i) { return { at: new Date(s.trim()).getTime(), label: (labels[i] || '').trim() }; })
      .filter(function (s) { return !isNaN(s.at); })
      .sort(function (a, b) { return a.at - b.at; });
    if (!stages.length) return;

    // The next date still ahead of us; once they are all past, the last one,
    // so the clock reads zero rather than jumping backwards.
    function pick() {
      var now = Date.now();
      for (var i = 0; i < stages.length; i++) if (stages[i].at > now) return stages[i];
      return stages[stages.length - 1];
    }

    var stage = pick();
    var deadline = stage.at;
    var labelEls = ROOT.querySelectorAll('[data-deadline-label]');

    function setStage(next) {
      stage = next;
      deadline = stage.at;
      labelEls.forEach(function (el) { el.textContent = stage.label; });
    }
    setStage(stage);

    var timer = null;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    /* Write a value only when it actually changed, and let the new figure
       settle into place. Two things keep this from reading as a flicker: it is
       driven by the actual change rather than a loop, and it never travels far
       from full opacity — the seconds cell repaints every second, so a deep
       fade there would look like a flash however smooth its easing. */
    function put(el, value) {
      if (!el || el.textContent === value) return;
      el.textContent = value;
      if (reduceMotion || typeof el.animate !== 'function') return;
      el.animate(
        [
          { transform: 'translateY(0.16em)', opacity: 0.6 },
          { transform: 'translateY(0)', opacity: 1 }
        ],
        { duration: 280, easing: 'cubic-bezier(.22,.7,.3,1)' }
      );
    }

    var drawn = false;
    function render() {
      var diff = deadline - Date.now();
      // This date has arrived: if the promotion has a later stage, count to
      // that one instead of stopping.
      if (diff <= 0) {
        var next = pick();
        if (next !== stage) {
          // A page that changes with its stages (<body data-stage-reload>, the
          // Holiday 2026 page) reloads into the next one rather than keep the
          // last stage's look under the new stage's clock.
          if (ROOT.hasAttribute('data-stage-reload')) { location.reload(); return true; }
          setStage(next); diff = deadline - Date.now();
        } else if (drawn && ROOT.getAttribute('data-end-redirect')) {
          // The last date, the offer's end, has passed with the page open: it
          // goes where a visit after the end goes (<body data-end-redirect>).
          location.replace(ROOT.getAttribute('data-end-redirect'));
          return true;
        }
      }
      drawn = true;
      var expired = diff <= 0;
      if (expired) diff = 0;

      var totalSec = Math.floor(diff / 1000);
      var parts = {
        days: Math.floor(totalSec / 86400),
        hours: Math.floor((totalSec % 86400) / 3600),
        minutes: Math.floor((totalSec % 3600) / 60),
        seconds: totalSec % 60
      };

      clocks.forEach(function (clock) {
        Object.keys(parts).forEach(function (key) {
          put(clock.querySelector('[data-unit="' + key + '"]'), pad(parts[key]));
        });
        put(clock.querySelector('[data-compact]'), parts.days > 0
          ? parts.days + 'd ' + pad(parts.hours) + 'h ' + pad(parts.minutes) + 'm'
          : pad(parts.hours) + ':' + pad(parts.minutes) + ':' + pad(parts.seconds));
      });

      if (expired) {
        ROOT.querySelectorAll('[data-expired-text]').forEach(function (el) {
          el.textContent = el.getAttribute('data-expired-text');
        });
      }
      return expired;
    }

    /* Tick on the real second boundary instead of every 1000ms. A plain
       interval drifts against the clock, so a digit would occasionally hold
       for two beats and then jump two. This re-aims after every render. */
    function schedule() {
      var diff = deadline - Date.now();
      var untilChange = ((diff % 1000) + 1000) % 1000 || 1000;
      timer = setTimeout(function () {
        if (!render()) schedule();
      }, untilChange + 20);
    }

    function restart() {
      clearTimeout(timer);
      if (!render()) schedule();
    }

    // Background tabs throttle timers, so the clock can be stale on return.
    // Re-read it on the way back rather than letting it catch up in one jump.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') restart();
    });

    restart();
  }

  /* ------------------------------------------------------------------------
     Scroll reveal
     ---------------------------------------------------------------------- */
  function initReveal() {
    var items = ROOT.querySelectorAll('[data-reveal]');
    if (!items.length) return;

    function revealAll() {
      items.forEach(function (el) { el.classList.add('ibf-is-in'); });
    }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.getAttribute('data-reveal-delay') || '0', 10);
        setTimeout(function () { entry.target.classList.add('ibf-is-in'); }, delay);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });

    // Safety net: IntersectionObserver does not deliver entries while a tab is
    // hidden (background tab, prerender). Without this the page would render
    // blank for anyone who opens it in the background and switches to it later.
    setTimeout(function () {
      var pending = ROOT.querySelectorAll('[data-reveal]:not(.ibf-is-in)');
      if (!pending.length) return;
      if (document.visibilityState === 'hidden') {
        revealAll();
        io.disconnect();
      }
    }, 2500);

    document.addEventListener('visibilitychange', function onShow() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', onShow);
      // Give the observer one frame to catch up; reveal anything it misses.
      setTimeout(function () {
        if (ROOT.querySelectorAll('[data-reveal].ibf-is-in').length === 0) revealAll();
      }, 400);
    });
  }

  /* ------------------------------------------------------------------------
     FAQ accordion (one open at a time)
     ---------------------------------------------------------------------- */
  function initFaq() {
    var items = ROOT.querySelectorAll('.ibf-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.ibf-faq__q');
      var panel = item.querySelector('.ibf-faq__a');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        items.forEach(function (other) {
          other.setAttribute('data-open', 'false');
          var b = other.querySelector('.ibf-faq__q');
          var p = other.querySelector('.ibf-faq__a');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (p) p.setAttribute('aria-hidden', 'true');
        });
        if (!isOpen) {
          item.setAttribute('data-open', 'true');
          btn.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     Sticky mobile buy bar — appears once the hero CTA scrolls away
     ---------------------------------------------------------------------- */
  function initBuyBar() {
    var bar = ROOT.querySelector('.ibf-buybar');
    var sentinel = ROOT.querySelector('[data-buybar-trigger]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    var ctaGone = false, atEnd = false;
    function sync() { bar.classList.toggle('ibf-is-visible', ctaGone && !atEnd); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { ctaGone = !entry.isIntersecting; });
      sync();
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(sentinel);
    // On the store the page ends above the theme's footer: the bar steps aside
    // once the end of the page is on screen, so it never covers the footer.
    var end = ROOT.querySelector('[data-buybar-end]');
    if (end) new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { atEnd = entry.isIntersecting || entry.boundingClientRect.top < 0; });
      sync();
    }).observe(end);
  }

  /* ------------------------------------------------------------------------
     Image fallback — swap to the inline SVG placeholder if a remote product
     shot fails to load, so the layout never shows a broken image.
     ---------------------------------------------------------------------- */
  function initImageFallback() {
    ROOT.querySelectorAll('img[data-fallback]').forEach(function (img) {
      img.addEventListener('error', function handle() {
        img.removeEventListener('error', handle);
        var target = document.getElementById(img.getAttribute('data-fallback'));
        if (!target) return;
        var clone = target.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('hidden');
        clone.setAttribute('role', 'img');
        clone.setAttribute('aria-label', img.getAttribute('alt') || '');
        if (img.parentNode) img.parentNode.replaceChild(clone, img);
      });
    });
  }

  /* ------------------------------------------------------------------------
     Count-up — a figure rolls from 0 to its value the first time it is seen.
     <span data-countup="325" data-prefix="$">$325</span>
     The real value is in the markup, so nothing depends on this running.
     ---------------------------------------------------------------------- */
  function initCountUp() {
    var els = ROOT.querySelectorAll('[data-countup]');
    if (!els.length || reduceMotion || !('IntersectionObserver' in window)) return;

    function run(el) {
      var target = parseFloat(el.getAttribute('data-countup'));
      if (isNaN(target)) return;
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var decimals = (String(target).split('.')[1] || '').length;
      var dur = 900;
      var t0 = null;

      function frame(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1 });
    // Low threshold on purpose: the figure sits inside a tile that can be
    // taller than a phone viewport, so 50% visibility could arrive late or
    // never, leaving the roll-up running while the user is already reading.

    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------------
     Scenes — the four product animations idle until scrolled into view.
     Four infinite CSS loops running off-screen is wasted battery, so the
     stylesheet leaves them paused and this adds .is-live on entry.
     ---------------------------------------------------------------------- */
  function initScenes() {
    var scenes = ROOT.querySelectorAll('[data-scene]');
    if (!scenes.length) return;

    if (!('IntersectionObserver' in window)) {
      scenes.forEach(function (s) { s.classList.add('ibf-is-live'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('ibf-is-live', entry.isIntersecting);
      });
    }, { rootMargin: '80px 0px', threshold: 0.12 });

    scenes.forEach(function (s) { io.observe(s); });

    // Same hidden-tab caveat as the reveals: if the observer never reports,
    // start them anyway rather than leaving four frozen panels.
    setTimeout(function () {
      if (!ROOT.querySelector('[data-scene].ibf-is-live') && document.visibilityState === 'hidden') {
        scenes.forEach(function (s) { s.classList.add('ibf-is-live'); });
      }
    }, 2500);
  }

  /* ------------------------------------------------------------------------
     Service reset — the only demo the reader drives themselves.
     The stylesheet owns every visual: this just holds .is-resetting on the
     panel for the length of the sequence, then hands it back to idle so the
     reset can be run again.
     ---------------------------------------------------------------------- */
  function initServiceReset() {
    var HOLD = 3200; // wind (1.4s) + label swap + a beat to read it

    ROOT.querySelectorAll('[data-service-reset]').forEach(function (btn) {
      var panel = btn.closest ? btn.closest('.ibf-capviz') : null;
      if (!panel) return;

      btn.addEventListener('click', function () {
        if (panel.classList.contains('ibf-is-resetting')) return;
        panel.classList.add('ibf-is-resetting');
        window.setTimeout(function () {
          panel.classList.remove('ibf-is-resetting');
        }, HOLD);
      });
    });
  }

  /* ------------------------------------------------------------------------
     Cart drawer — "Add to cart" slides in a cart holding the 5610 and its
     gifts, then hands off to the real cart on innova.com.

     The store lives on innova.com, another domain, so this page cannot write
     into its cart. The drawer is the review step; Checkout goes to the page's
     own cart link (<body data-checkout>: a cart permalink that puts the whole
     bundle in the innova.com cart with the page's discount code applied), or,
     without one, to innova.com's /cart/add with the 5610 alone.
     Without JS, or without <dialog>, every trigger stays a plain link to the
     product page.

     A page names the items its bundle holds, by id, on
     <body data-cart-items="5610 carmd=100 giftcard">. Without it the drawer
     holds every item below; the totals are computed from whatever it holds.

     Stock comes from <body data-stock-left data-stock-total>, which must be
     the real remaining gift allocation. The figure animates down to that
     number when the cart opens; it never ticks on a timer, because a counter
     that invents depletion is exactly the fake scarcity the FTC and EU
     consumer rules single out. A page that states the share already gone
     instead of counts says so with <body data-stock-gone="70">: the same card
     reads "70% gone" — the figure rises to it once, and the bar, the stock
     that's left as with counts, drains to the other 30% (Joseph, 1 Oct).
     data-stock-source="sample" labels the figures as samples in the drawer,
     so placeholders cannot go live unnoticed.
     ---------------------------------------------------------------------- */
  var BUNDLE = {
    checkout: 'https://www.innova.com/cart/add?id=32524554436654&quantity=1',
    total: 349.99,
    items: [
      { id: '5610', name: 'Innova 5610 CarScan Pro', note: 'Bidirectional scan tool', price: 349.99, was: 549.99,
        img: 'https://www.innova.com/cdn/shop/files/Group_1000006217_1.png?v=1760469925&width=160', fallback: 'ibf-svg-5610' },
      { id: 'carmd', name: 'CarMD Connect', note: 'Vehicle tracker', was: 150, gift: true,
        img: 'https://carmd.com/cdn/shop/files/ChatGPT_Image_Jun_26_2026_10_16_15_AM.png?v=1782494192&width=160', fallback: 'ibf-svg-carmd' },
      { id: '1000', name: 'Innova 1000', note: 'Bluetooth OBD2 dongle', was: 100, gift: true,
        img: 'https://www.innova.com/cdn/shop/files/1_1000_Main-Image_4.png?v=1744741155&width=160', fallback: 'ibf-svg-1000' },
      { id: 'giftcard', name: 'Innova gift card', note: 'Virtual: spend it or send it', was: 20, gift: true,
        img: '/assets/img/gift-card-thumb.webp' }
    ]
  };

  // On the store the gift card's thumbnail is a theme asset; the section hands over its URL.
  (function () {
    var gc = ROOT.getAttribute('data-giftcard-img');
    if (gc) BUNDLE.items.forEach(function (it) { if (it.id === 'giftcard') it.img = gc; });
  })();

  function money(n) { return '$' + n.toFixed(2); }

  /* ------------------------------------------------------------------------
     Dates in the copy — <span data-date="offer-end">Dec 31</span> shows the
     date on <body data-offer-end>, in Pacific time, so the words can't drift
     from the dates the page runs on (on the store, section settings can move
     them). data-date-style="long" gives "December 31", "time" gives
     "11:59 PM"; the default is "Dec 31". The markup carries today's wording,
     for anyone without JavaScript.
     ---------------------------------------------------------------------- */
  function formatDate(iso, style) {
    var d = new Date(iso || '');
    if (isNaN(d.getTime())) return '';
    var o = style === 'time' ? { hour: 'numeric', minute: '2-digit' }
      : { month: style === 'long' ? 'long' : 'short', day: 'numeric' };
    o.timeZone = 'America/Los_Angeles';
    try { return style === 'time' ? d.toLocaleTimeString('en-US', o) : d.toLocaleDateString('en-US', o); }
    catch (e) { return ''; }
  }

  function initDates() {
    ROOT.querySelectorAll('[data-date]').forEach(function (el) {
      var text = formatDate(ROOT.getAttribute('data-' + el.getAttribute('data-date')), el.getAttribute('data-date-style'));
      if (text) el.textContent = text;
    });
  }

  // Shipping's line in the drawer has no product to picture, so it gets a truck.
  var TRUCK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="5.5" width="11" height="9.5" rx="1"/>' +
    '<path d="M13 8.5h4l3.5 3.5v3H13"/><circle cx="6.5" cy="17" r="1.9"/><circle cx="16.5" cy="17" r="1.9"/></svg>';

  function cartMarkup(stock, timer, pct, addon, staged) {
    var worth = BUNDLE.items.reduce(function (sum, it) { return sum + (it.was || it.price); }, 0);
    var gifts = BUNDLE.items.filter(function (it) { return it.gift; }).length;
    var shipLine = BUNDLE.items.some(function (it) { return it.ship; });

    var rows = BUNDLE.items.map(function (it, i) {
      // Shipping, when the page values it, is a line rather than a product: one
      // compact row, struck through to Free like the gifts.
      if (it.ship) {
        return '<li class="ibf-cart__item ibf-cart__item--ship" style="--i:' + i + '">' +
          '<span class="ibf-cart__thumb">' + TRUCK + '</span>' +
          '<span class="ibf-cart__desc"><span class="ibf-cart__name">' + it.name + '</span></span>' +
          '<span class="ibf-cart__price"><s class="ibf-num">' + money(it.was) + '</s><span class="ibf-cart__free">Free</span></span></li>';
      }
      var art = it.sprite
        ? '<svg viewBox="0 0 120 120" aria-hidden="true"><use href="#' + it.sprite + '"/></svg>'
        : '<img src="' + it.img + '" alt="" width="80" height="80" loading="lazy"' +
          (document.getElementById(it.fallback) ? ' data-fallback="' + it.fallback + '"' : '') + '>';
      var price = it.gift
        ? '<s class="ibf-num">' + money(it.was) + '</s><span class="ibf-cart__free">Free</span>'
        : '<s class="ibf-num">' + money(it.was) + '</s><span class="ibf-num">' + money(it.price) + '</span>';
      return '<li class="ibf-cart__item' + (it.gift ? ' ibf-cart__item--gift' : '') + '" style="--i:' + i + '">' +
        '<span class="ibf-cart__thumb">' + art + '</span>' +
        '<span class="ibf-cart__desc"><span class="ibf-cart__name">' + it.name + '</span>' +
        '<span class="ibf-cart__note">' + (it.gift ? 'Free gift · ' : '') + it.note + '</span></span>' +
        '<span class="ibf-cart__price">' + price + '</span></li>';
    }).join('');

    var stockBlock = stock
      ? '<section class="ibf-cart__stock" aria-labelledby="ibf-cart-stock-label">' +
          '<div class="ibf-cart__stock-top"><span id="ibf-cart-stock-label" class="ibf-cart__stock-label">' +
            '<i class="ibf-cart__stock-dot" aria-hidden="true"></i>Limited gift stock</span>' +
            (stock.sample ? '<span class="ibf-cart__sample">Sample numbers</span>' : '') + '</div>' +
          (stock.gone !== undefined
            ? '<p class="ibf-cart__stock-count"><b class="ibf-num" data-stock-count aria-hidden="true">' + stock.gone + '%</b>' +
                '<span aria-hidden="true"> gone</span>' +
                '<span class="ibf-sr-only">' + stock.gone + '% of gift bundles gone</span></p>'
            : '<p class="ibf-cart__stock-count"><b class="ibf-num" data-stock-count aria-hidden="true">' + stock.left + '</b>' +
                '<span aria-hidden="true"> of ' + stock.total + ' gift bundles left</span>' +
                '<span class="ibf-sr-only">' + stock.left + ' of ' + stock.total + ' gift bundles left</span></p>') +
          '<div class="ibf-cart__bar" aria-hidden="true"><i data-stock-bar></i></div>' +
          // A page whose clock counts to its current stage rather than to the end
          // of the offer (<body data-offer-end>) has no countdown to put here, and
          // names no date either (Joseph, 6 Oct): the note stops at the gifts.
          '<p class="ibf-cart__stock-note">Ends when the gifts run out' +
            (staged ? ''
              : ', or in <span data-countdown><span class="ibf-num" data-compact>&ndash;</span></span>.') + '</p>' +
        '</section>'
      : '';

    // A page that knows the share of its allocation already claimed, but not
    // the raw counts, states that instead. Same rule as the counts: it is a
    // figure the page was given, drawn once. Nothing here ticks by itself.
    var pctBlock = pct
      ? '<section class="ibf-cart__stock ibf-cart__stock--pct">' +
          '<div class="ibf-cart__stock-top">' +
            '<span class="ibf-cart__stock-label"><i class="ibf-cart__stock-dot" aria-hidden="true"></i>Limited quantity</span>' +
            '<span class="ibf-cart__stock-pct"><b class="ibf-num">' + pct.claimed + '%</b> claimed</span>' +
          '</div>' +
          '<div class="ibf-cart__bar" role="img" aria-label="' + pct.claimed + ' percent of this offer’s gift bundles have been claimed">' +
            '<i data-stock-bar style="width:' + pct.claimed + '%"></i></div>' +
        '</section>'
      : '';

    // Recommended add-on, off unless the reader turns it on.
    var addonBlock = addon
      ? '<section class="ibf-cart__addon">' +
          '<div class="ibf-cart__addon-head">' +
            '<span class="ibf-cart__addon-eyebrow">Recommended add-on</span>' +
            '<button class="ibf-cart__switch" type="button" role="switch" aria-checked="false" data-addon-toggle' +
              ' aria-label="Add ' + addon.name + (addon.badge ? ', ' + addon.badge : '') + ', ' + money(addon.price) + '"><i></i></button>' +
          '</div>' +
          '<div class="ibf-cart__addon-row">' +
            (addon.img ? '<span class="ibf-cart__addon-thumb"><img src="' + addon.img + '" alt="" width="80" height="80" loading="lazy"></span>' : '') +
            '<span class="ibf-cart__addon-name">' + addon.name +
              (addon.badge ? ' <span class="ibf-cart__addon-badge">' + addon.badge + '</span>' : '') + '</span>' +
            '<span class="ibf-cart__addon-price">+' + money(addon.price) + '</span>' +
          '</div>' +
          (addon.note ? '<p class="ibf-cart__addon-note">' + addon.note + '</p>' : '') +
        '</section>'
      : '';

    // The page's own end date, across the top of the drawer. It reads from
    // data-deadline like every other clock here, so the drawer can never
    // claim an urgency the page itself does not have.
    var timerBar = timer
      ? '<div class="ibf-cart__timer" data-countdown>' +
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
          (timer.labelled ? 'Ends <b data-deadline-label></b> &middot; ' : 'Offer ends in ') +
          '<span class="ibf-num" data-compact data-expired-text="Ended">&ndash;</span>' +
        '</div>'
      : '';

    return '<div class="ibf-cart__panel">' +
      timerBar +
      '<header class="ibf-cart__head">' +
        '<h2 class="ibf-cart__title" id="ibf-cart-title">Your cart</h2>' +
        '<span class="ibf-cart__count">1 bundle &middot; ' + gifts + ' free gifts</span>' +
        '<button class="ibf-cart__close" type="button" data-cart-close aria-label="Close cart">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</header>' +
      '<div class="ibf-cart__body">' +
        '<p class="ibf-cart__added"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
          'Bundle added. Gifts are added at checkout</p>' +
        stockBlock +
        pctBlock +
        '<ul class="ibf-cart__items">' + rows + '</ul>' +
        addonBlock +
      '</div>' +
      '<footer class="ibf-cart__foot">' +
        // The hooks the add-on needs to rewrite the figures exist only on a
        // page that has an add-on, so every other drawer is untouched.
        '<dl class="ibf-cart__sum">' +
          '<div><dt>Subtotal</dt><dd class="ibf-num"' + (addon ? ' data-cart-subtotal' : '') + '>' + money(BUNDLE.total) + '</dd></div>' +
          (addon ? '<div class="ibf-cart__addon-line" hidden><dt>' + addon.name +
            (addon.badge ? ' (' + addon.badge + ')' : '') + '</dt><dd class="ibf-num">+' + money(addon.price) + '</dd></div>' : '') +
          '<div class="ibf-cart__save"><dt>You save</dt><dd class="ibf-num">' + money(worth - BUNDLE.total) + '</dd></div>' +
          // Listed as its own line above, shipping isn't repeated here.
          (shipLine ? '' : '<div><dt>Shipping</dt><dd>Free</dd></div>') +
        '</dl>' +
        '<a class="ibf-cart__checkout" href="' + BUNDLE.checkout + '" data-cta="checkout">Checkout: ' +
          (addon ? '<span data-cart-total>' + money(BUNDLE.total) + '</span>' : money(BUNDLE.total)) + '</a>' +
        '<p class="ibf-cart__fine">Secure checkout on innova.com &middot; 30-day money back</p>' +
        '<button class="ibf-cart__keep" type="button" data-cart-close>Keep shopping</button>' +
      '</footer>' +
    '</div>';
  }

  function initCart() {
    var triggers = ROOT.querySelectorAll('[data-cart]');
    if (!triggers.length) return;

    var probe = document.createElement('dialog');
    if (typeof probe.showModal !== 'function') return;

    var body = ROOT;
    // Each entry is an item id, optionally with the value this page puts on
    // it: "giftcard=50" for a page running a $50 card where others run $20.
    var only = (body.getAttribute('data-cart-items') || '').split(/\s+/).filter(Boolean)
      .map(function (part) { var bits = part.split('='); return { id: bits[0], was: parseFloat(bits[1]) }; });
    if (only.length) {
      BUNDLE.items = BUNDLE.items.filter(function (it) {
        for (var i = 0; i < only.length; i++) {
          if (only[i].id !== it.id) continue;
          if (!isNaN(only[i].was)) it.was = only[i].was;
          return true;
        }
        return false;
      });
    }
    // <body data-shipping-value="10"> counts free shipping at that value: it
    // gets its own struck-through line and joins "You save". Without it,
    // shipping stays a plain "Free" in the totals, as on every other page.
    var shipValue = parseFloat(body.getAttribute('data-shipping-value'));
    if (shipValue > 0) BUNDLE.items.push({ id: 'shipping', name: 'Shipping', was: shipValue, ship: true });
    var left = parseInt(body.getAttribute('data-stock-left'), 10);
    var total = parseInt(body.getAttribute('data-stock-total'), 10);
    var gone = parseFloat(body.getAttribute('data-stock-gone'));
    var sample = body.getAttribute('data-stock-source') === 'sample';
    var stock = (left >= 0 && total > 0 && left <= total) ? { left: left, total: total, sample: sample }
      : (gone >= 0 && gone <= 100) ? { gone: gone, sample: sample }
      : null;

    // <body data-cart-timer> puts that page's end date at the top of the
    // drawer; without a deadline there is nothing honest to count, so the
    // bar is left out.
    var timer = (body.hasAttribute('data-cart-timer') && body.getAttribute('data-deadline'))
      ? { labelled: !!body.getAttribute('data-deadline-labels') }
      : null;

    // A page that knows the share claimed but not the raw counts says so with
    // <body data-stock-claimed="90">. Same standing rule as the counts: a real
    // figure, drawn once, never made to climb on its own.
    var claimed = parseFloat(body.getAttribute('data-stock-claimed'));
    var pct = (!stock && claimed >= 0 && claimed <= 100) ? { claimed: claimed } : null;

    // Recommended add-on, described by the page:
    //   data-addon-name / -badge / -price / -note / -img
    // and one of two ways to actually sell it:
    //   data-addon-checkout — the whole checkout URL for the with-add-on case
    //   data-addon-variant  — its Shopify variant, paired with the tool's
    // With neither, the switch still moves the figures in the drawer but the
    // checkout cannot add the plan, so a page must not go live offering an
    // add-on until one of them is set.
    // A page can point the drawer at its own checkout link, for when the store
    // wants a different one than the shared cart/add above.
    var pageCheckout = body.getAttribute('data-checkout');
    if (pageCheckout) BUNDLE.checkout = pageCheckout;

    var addonPrice = parseFloat(body.getAttribute('data-addon-price'));
    var addon = !isNaN(addonPrice) ? {
      price: addonPrice,
      name: body.getAttribute('data-addon-name') || 'Add-on',
      badge: body.getAttribute('data-addon-badge') || '',
      note: body.getAttribute('data-addon-note') || '',
      img: body.getAttribute('data-addon-img') || '',
      variant: body.getAttribute('data-addon-variant') || '',
      checkout: body.getAttribute('data-addon-checkout') || ''
    } : null;

    var dialog = document.createElement('dialog');
    dialog.className = 'ibf-cart';
    dialog.setAttribute('aria-labelledby', 'ibf-cart-title');
    // A page with an end of its own (<body data-offer-end>) runs in stages: its
    // clock counts to the current stage, so the stock note carries no countdown.
    var staged = !!formatDate(body.getAttribute('data-offer-end'));
    dialog.innerHTML = cartMarkup(stock, timer, pct, addon, staged);
    body.appendChild(dialog);

    // Checkout wears the page's own primary button, so it matches each design
    // without the drawer having to know which one it is on.
    var primary = triggers[0];
    var checkout = dialog.querySelector('.ibf-cart__checkout');
    primary.classList.forEach(function (c) {
      if (c.indexOf('ibf-btn') === 0 && !/--(sm|lg|block|pulse)$/.test(c)) checkout.classList.add(c);
    });
    checkout.classList.add('ibf-btn--block');

    var count = dialog.querySelector('[data-stock-count]');
    var bar = dialog.querySelector('[data-stock-bar]');
    var lastTrigger = null;
    var closing = null;

    // The bar is always the stock that's left. Counts: the figure is what is
    // left, the bar its share of the whole. A stated share gone: the figure is
    // that share, the bar the rest (75% gone: a quarter of the bar).
    function drawStock(value) {
      var share = stock.gone !== undefined;
      if (count) count.textContent = Math.round(value) + (share ? '%' : '');
      if (bar) bar.style.width = (share ? 100 - value : value / stock.total * 100).toFixed(2) + '%';
    }

    // Counts run down from the full allocation to what is really left, and
    // the bar drains with them; a share gone rises from nothing to the stated
    // figure while the bar drains to what's left. Presentation of the real
    // figure, once, nothing more.
    function runStock() {
      // Share-claimed pages have no counts to run down: the bar draws once to
      // the stated figure and stops there.
      if (pct) {
        if (!bar) return;
        if (reduceMotion) { bar.style.width = pct.claimed + '%'; return; }
        bar.style.width = '0%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bar.style.transition = 'width 1.1s cubic-bezier(.3,.8,.3,1)';
            bar.style.width = pct.claimed + '%';
          });
        });
        return;
      }
      if (!stock) return;
      var from = stock.gone !== undefined ? 0 : stock.total;
      var to = stock.gone !== undefined ? stock.gone : stock.left;
      if (reduceMotion) { drawStock(to); return; }
      drawStock(from);
      var t0 = null, dur = 1200;
      function frame(t) {
        if (!dialog.open) return;
        if (t0 === null) t0 = t + 260; // let the panel arrive first
        var p = Math.max(0, Math.min(1, (t - t0) / dur));
        var eased = 1 - Math.pow(1 - p, 3);
        drawStock(from + (to - from) * eased);
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    // Hiding overflow removes the scrollbar, so its width goes back as padding
    // (see html.cart-lock) and nothing behind the drawer shifts. Measured only
    // on the way in: once locked, the scrollbar is already gone and reads as 0.
    function lock(on) {
      var root = document.documentElement;
      if (on && !root.classList.contains('ibf-cart-lock')) {
        root.style.setProperty('--cart-sbw', (window.innerWidth - root.clientWidth) + 'px');
      }
      root.classList.toggle('ibf-cart-lock', on);
      if (!on) root.style.removeProperty('--cart-sbw');
    }

    function open(trigger) {
      clearTimeout(closing);
      lastTrigger = trigger;
      if (!dialog.open) dialog.showModal();
      lock(true);
      void dialog.offsetWidth; // commit the closed position so the slide runs
      dialog.classList.add('ibf-is-open');
      runStock();
    }

    function close() {
      if (!dialog.open) return;
      dialog.classList.remove('ibf-is-open');
      function done() {
        if (dialog.classList.contains('ibf-is-open')) return; // reopened meanwhile
        dialog.close();
        lock(false);
        if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      }
      if (reduceMotion) { done(); return; }
      closing = setTimeout(done, 380);
    }

    // The add-on switch. Off when the drawer is built, and the reader's own
    // choice after that: it only ever changes what is shown and where the
    // checkout points, never what is already in the bundle.
    if (addon) {
      var sw = dialog.querySelector('[data-addon-toggle]');
      var addonLine = dialog.querySelector('.ibf-cart__addon-line');
      var subtotalEl = dialog.querySelector('[data-cart-subtotal]');
      var totalEl = dialog.querySelector('[data-cart-total]');
      var mainVariant = (BUNDLE.checkout.match(/[?&]id=(\d+)/) || [])[1];

      if (sw) sw.addEventListener('click', function () {
        var on = sw.getAttribute('aria-checked') !== 'true';
        sw.setAttribute('aria-checked', on ? 'true' : 'false');
        dialog.classList.toggle('ibf-has-addon', on);
        if (addonLine) addonLine.hidden = !on;

        var total = BUNDLE.total + (on ? addon.price : 0);
        if (subtotalEl) subtotalEl.textContent = money(total);
        if (totalEl) totalEl.textContent = money(total);

        // Hand the choice to the store only when there is something to hand
        // it: a checkout link for the with-add-on case, or both variants in
        // one cart permalink. With neither, the link is left alone rather
        // than pointed at a cart that cannot carry the plan.
        if (addon.checkout) {
          checkout.href = on ? addon.checkout : BUNDLE.checkout;
        } else if (addon.variant && mainVariant) {
          checkout.href = on
            ? 'https://www.innova.com/cart/' + mainVariant + ':1,' + addon.variant + ':1'
            : BUNDLE.checkout;
        }
      });
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        // Leave new-tab and modified clicks to the browser.
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        open(t);
      });
    });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    // The dimmed area is the dialog itself. Only a press that starts there
    // closes it — a text selection dragged out of the panel must not.
    var pressedBackdrop = false;
    dialog.addEventListener('pointerdown', function (e) { pressedBackdrop = e.target === dialog; });
    dialog.addEventListener('click', function (e) {
      if ((e.target === dialog && pressedBackdrop) || e.target.closest('[data-cart-close]')) close();
    });
  }

  /* ------------------------------------------------------------------------
     Starfield — a still, faintly twinkling backdrop for the hero.
     Deliberately slow and low-contrast: it should read as depth, not motion.
     ---------------------------------------------------------------------- */
  function initStars() {
    var canvas = ROOT.querySelector('[data-stars]');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var stars = [];
    var raf = null;
    var w = 0;
    var h = 0;
    var t = 0;

    // Themed from CSS so a campaign stylesheet can recolour the field by
    // setting --star-tint, rather than this file knowing about any one palette.
    var tint = (getComputedStyle(canvas).getPropertyValue('--star-tint') || '').trim() || '232,121,249';

    function size() {
      var rect = canvas.parentElement.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = rect.width;
      h = rect.height;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      build();
      draw();
    }

    function build() {
      var count = Math.min(130, Math.round((w * h) / 9000));
      stars = [];
      for (var i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.25 + 0.35,
          base: Math.random() * 0.4 + 0.12,
          amp: Math.random() * 0.22,
          phase: Math.random() * Math.PI * 2,
          speed: Math.random() * 0.6 + 0.25,
          // A few stars pick up the violet cast of the hero glow.
          tint: Math.random() < 0.22
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        var a = s.base + Math.sin(t * s.speed + s.phase) * s.amp;
        if (a < 0.02) continue;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.tint
          ? 'rgba(' + tint + ',' + a + ')'
          : 'rgba(255,255,255,' + a + ')';
        ctx.fill();
      }
    }

    function frame() {
      t += 0.016;
      draw();
      raf = requestAnimationFrame(frame);
    }

    size();

    // Static field when motion is reduced — the stars still render, they just
    // stop twinkling.
    if (reduceMotion) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !raf) {
            raf = requestAnimationFrame(frame);
          } else if (!entry.isIntersecting && raf) {
            cancelAnimationFrame(raf);
            raf = null;
          }
        });
      }, { threshold: 0 }).observe(canvas.parentElement);
    } else {
      raf = requestAnimationFrame(frame);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(size, 180);
    });
  }

  /* ------------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */
  // The store's header and announcement bar are pinned above the page; measure
  // them when needed, since their height depends on the screen and the theme.
  function pinnedTop() {
    var bottom = 0;
    document.querySelectorAll('header, #header-group > *, [class*="announcement"]').forEach(function (el) {
      if (ROOT.contains(el)) return;
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      if (!r.height || r.height > window.innerHeight * 0.4) return;
      if (cs.position === 'fixed' && r.top <= 1) bottom = Math.max(bottom, r.bottom);
      else if (cs.position === 'sticky') bottom = Math.max(bottom, (parseFloat(cs.top) || 0) + r.height);
    });
    return bottom;
  }

  function initAnchors() {
    ROOT.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target || !ROOT.contains(target)) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - pinnedTop() - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  function boot() {
    // The cart builds its markup first: the countdown and the image fallback
    // collect their elements once, and the drawer holds one of each.
    initCart();
    initDates();
    initCountdown();
    initReveal();
    initFaq();
    initBuyBar();
    initImageFallback();
    initScenes();
    initServiceReset();
    initCountUp();
    initStars();
    initAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
};
if (document.getElementById('innova-bf')) window.__ibfInit();

/* AC Joseph v2: vanilla port of the Claude Design component (checkout swap, sticky bar
   trigger, $ count-down to zero, scroll-scrubbed video). */
(function () {
  'use strict';
  var R = document.getElementById('innova-bf');
  if (!R) return;
  var co = R.getAttribute('data-ac-checkout');
  if (co) {
    var base = R.getAttribute('data-checkout-pre');
    R.querySelectorAll('a[href]').forEach(function (a) { if (a.getAttribute('href') === base) a.setAttribute('href', co); });
  }
  function onScroll() {
    var hero = R.querySelector('.ibf-hero');
    R.classList.toggle('ibf-scrolled', !!hero && hero.getBoundingClientRect().bottom < 0);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  var zeros = R.querySelectorAll('.ibf-own__zero[data-from]');
  if (zeros.length && 'IntersectionObserver' in window) {
    var run = function (el) {
      var from = +el.getAttribute('data-from'), t0 = performance.now(), dur = 1600;
      var step = function (t) {
        var k = Math.min(1, (t - t0) / dur), v = Math.round(from * Math.pow(1 - k, 3));
        el.textContent = '$' + v;
        if (k < 1) requestAnimationFrame(step);
      };
      el.textContent = '$' + from; requestAnimationFrame(step);
    };
    zeros.forEach(function (el) { el.textContent = '$' + el.getAttribute('data-from'); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) {
      if (en.isIntersecting) { io.unobserve(en.target); setTimeout(function () { run(en.target); }, 250); }
    }); }, { threshold: 0.6 });
    zeros.forEach(function (el) { io.observe(el); });
  }

  // On the store the theme header and the page's own buy bar are fixed over the top of the
  // screen; Claude Design had neither, so the pinned video sat under them. Measure them live.
  function obstruct() {
    var b = 0;
    document.querySelectorAll('header, #header-group > *, [class*="announcement"], #innova-bf .ibf-buybar').forEach(function (el) {
      var cs = getComputedStyle(el); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect(); if (!r.height || r.height > window.innerHeight * 0.4 || r.top > 1 || r.bottom <= 0) return;
      b = Math.max(b, r.bottom);
    });
    return b;
  }
  var track = R.querySelector('.ibf-scrub__track');
  var v = R.querySelector('video[data-ac-video]');
  if (!track) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CLIPS = [[0.6, 8.5], [8.5, 15.9], [15.9, 24.4], [24.4, 33.5]];
  var cur = 0, activeStep = 0;
  if (v) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.removeAttribute('controls'); v.loop = false; v.autoplay = false;
    var unlocked = false;
    var unlock = function () { if (unlocked) return; var pr = v.play(); if (pr && pr.then) pr.then(function () { v.pause(); unlocked = true; }).catch(function () {}); else { v.pause(); unlocked = true; } };
    ['touchstart','scroll','pointerdown'].forEach(function (e) { window.addEventListener(e, unlock, { passive: true, once: true }); });
    if (v.readyState === 0) v.load();
    v.addEventListener('loadeddata', unlock, { once: true });
    var src = v.currentSrc || v.getAttribute('src');
    if (src && !/^blob:/.test(src) && window.fetch) {
      fetch(src).then(function (r) { return r.ok ? r.blob() : null; }).then(function (b) {
        if (!b) return;
        var t = v.currentTime;
        v.src = URL.createObjectURL(b);
        v.addEventListener('loadedmetadata', function () { v.currentTime = reduce ? 3 : t; cur = v.currentTime; unlock(); }, { once: true });
      }).catch(function () {});
    }
    if (reduce) {
      var park = function () { v.pause(); v.currentTime = Math.min(3, (v.duration || 3) - 0.05); };
      if (v.readyState >= 1) park(); else v.addEventListener('loadedmetadata', park, { once: true });
    }
  }
  var steps = [].slice.call(track.querySelectorAll('.ibf-scrub__step'));
  function setActive(a) {
    if (a === activeStep) return; activeStep = a;
    steps.forEach(function (el, i) { el.setAttribute('data-active', String(i === a)); });
  }
  function tick() {
    requestAnimationFrame(tick);
    if (reduce || !steps.length) return;
    var vh = window.innerHeight;
    var mobile = window.matchMedia('(max-width: 860px)').matches;
    var top = obstruct();
    var zz = parseFloat(getComputedStyle(R).zoom) || 1;
    R.style.setProperty('--ibf-pin-top', (top / zz) + 'px');
    var focus = mobile ? top + vh * 0.45 + (vh - top - vh * 0.45) / 2 : top + (vh - top) / 2;
    var z = parseFloat(getComputedStyle(R).zoom) || 1;
    var tr = track.getBoundingClientRect();
    var k = (z < 0.99 && track.offsetHeight && Math.abs(tr.height / track.offsetHeight - 1) < 0.02) ? z : 1;
    var rects = steps.map(function (el) { var b = el.getBoundingClientRect(); return { top: b.top * k, bottom: b.bottom * k, height: b.height * k }; });
    var active = 0, target;
    if (focus < rects[0].top) {
      target = (v && v.duration >= 33 ? 0.6 : 0) * Math.min(1, Math.max(0, 1 - (rects[0].top - focus) / (vh * 0.5)));
    } else {
      active = rects.length - 1;
      for (var i = 0; i < rects.length; i++) if (focus < rects[i].bottom) { active = i; break; }
      var r = rects[active];
      var p = Math.min(1, Math.max(0, (focus - r.top) / Math.max(1, r.height)));
      var d = v && isFinite(v.duration) ? v.duration : 0;
      var seg = d >= 33 ? CLIPS[active] : [d * active / 4, d * (active + 1) / 4];
      target = seg[0] + p * (seg[1] - seg[0]);
    }
    if (v && v.readyState >= 1 && isFinite(v.duration)) {
      target = Math.min(Math.max(0.6, v.duration - target), v.duration - 0.05);
      if (Math.abs(target - cur) > 4) cur = target;
      cur += (target - cur) * 0.15;
      if (Math.abs(target - cur) < 0.002) cur = target;
      if (!v.seeking && Math.abs(v.currentTime - cur) > 0.01) v.currentTime = cur;
    }
    setActive(active);
  }
  requestAnimationFrame(tick);
})();
